document.addEventListener('DOMContentLoaded', () => {

  const filterButtons = document.querySelectorAll('.quick-filter');
  const products = document.querySelectorAll('.boost-pfs-filter-product-item');

  filterButtons.forEach(button => {

    button.addEventListener('click', () => {

      // Active state
      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      const selectedFilter = button.dataset.filter;

      products.forEach(product => {

        const collections =
          product.dataset.productCollections.split(',');

        if (
          selectedFilter === 'all' ||
          collections.includes(selectedFilter)
        ) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }

      });

    });

  });

});
